<template>
    <div class="EmployeeCheckIn">
        <button class="form-control btn" v-bind:class="[CheckedIn ? 'btn-warning' : 'olive-green']" @click="ShowToggledCheckInOutModal">{{ CheckedIn ? "CHECK OUT OF HOUSE" : "CHECK IN TO HOUSE" }}</button>

        <!--CHECK IN/OUT MODAL-->
        <b-modal ref="toggle-modal" size="sm" :title="ToggleModalTitle" hide-footer>
            <b-container>
                <b-row>
                    <div class="form-group">
                        <label>Check {{ DirectionString }} Date:</label>
                        <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="TargetDate"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Check {{ DirectionString }} Time:</label>
                        <flat-pickr class="form-control" :config="TimeInputConfigSchema" v-model="TargetTime"></flat-pickr>
                    </div>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CANCEL
                        </b-button>
                        <b-button size="md" variant="success" type="button" @click="ToggleCheckInStatus">
                            CHECK {{ DirectionString }}
                        </b-button>
                    </div>

                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    //library.add(faSyncAlt);

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        created() {
            let vm = this;
            EventBus.$on('update-check-in-status', payload => {
                if (payload.ResidenceID == vm.ResidenceId) {
                    vm.CheckedIn = payload.Status;
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('update-check-in-status');
        },
        props: [
            "ResidenceId"
        ],
        data: function () {
            return {
                CheckedIn: false,
                ToggleModalTitle: "",
                DirectionString: "",
                TargetDate: "",
                TargetTime: "",
                DateInputConfigSchema: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                TimeInputConfigSchema: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'h:i K',
                    onChange: function (selectedDates, dateStr, instance) {
                        if (dateStr === '') { instance.close(); }
                    }
                }
            };
        },
        methods: {
            ShowToggledCheckInOutModal() {
                //moment().format("YYYY-MM-DD HH:mm");
                this.TargetDate = moment().format("YYYY-MM-DD");
                this.TargetTime = moment().format("HH:mm");
                this.ToggleModalTitle = this.CheckedIn ? "Check Out of House" : "Check In to House";
                this.DirectionString = this.CheckedIn ? "OUT" : "IN";

                this.$refs["toggle-modal"].show();
            },
            ToggleCheckInStatus() {
                let endpoint = this.CheckedIn ? "CheckOutEmployee" : "CheckInEmployee";
                this.$MasterAPI.ExecuteRequest("POST", "Residential/EmployeeCheckIn/" + endpoint, { EmployeeID: this.UserPrivateProfile.EmployeeID, ResidenceID: this.ResidenceId, TargetDateTime: this.combineTargetDateTimes() }, this.ToggleCheckInStatusSuccess, () => { }, true);
            },
            ToggleCheckInStatusSuccess(response) {
                this.CheckedIn = !this.CheckedIn;//toggle
                EventBus.$emit('update-residence-list');
                EventBus.$emit('update-check-in-status', { Status: this.CheckedIn, ResidenceID: this.ResidenceId });
                this.$refs["toggle-modal"].hide();
            },
            GetCheckInStatus() {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/EmployeeCheckIn/GetEmployeeCheckInStatus", { EmployeeID: this.UserPrivateProfile.EmployeeID, ResidenceID: this.ResidenceId }, this.GetCheckInStatusSuccess, () => { }, false);
            },
            GetCheckInStatusSuccess(response) {
                this.CheckedIn = response.data.data;
            },
            Cancel() {
                this.$refs["toggle-modal"].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            combineTargetDateTimes() {

                let output = this.TargetDate + " " + this.TargetTime;
                console.log(output);
                return output;
            }
            
        },
        components: {
            flatPickr
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            }
        },
        mounted() {
            this.GetCheckInStatus();
        }
    }
</script>

<style scoped>
</style>